"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M19 21V10C19 6.13401 15.866 3 12 3V3C8.13401 3 5 6.13401 5 10V21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }));
